import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VersionSelector = ({ versions, selectedVersion, onVersionSelect }) => {
  const [viewMode, setViewMode] = useState('cards'); // 'cards' or 'list'

  if (!versions || versions?.length <= 1) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
            <Icon name="Layers" size={20} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Seleccionar Versión</h3>
            <p className="text-sm text-muted-foreground">{versions?.length} versiones disponibles</p>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant={viewMode === 'cards' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setViewMode('cards')}
            iconName="Grid3X3"
            iconSize={14}
          >
            Tarjetas
          </Button>
          <Button
            variant={viewMode === 'list' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setViewMode('list')}
            iconName="List"
            iconSize={14}
          >
            Lista
          </Button>
        </div>
      </div>
      {viewMode === 'cards' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {versions?.map((version) => (
            <div
              key={version?.id}
              className={`p-4 border rounded-lg cursor-pointer transition-smooth ${
                selectedVersion?.id === version?.id
                  ? 'border-primary bg-primary/5 shadow-elevation'
                  : 'border-border hover:border-primary/50 hover:shadow-elevation'
              }`}
              onClick={() => onVersionSelect(version)}
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <h4 className="font-medium text-foreground mb-1">{version?.trim}</h4>
                  <p className="text-sm text-muted-foreground">{version?.description}</p>
                </div>
                {selectedVersion?.id === version?.id && (
                  <Icon name="CheckCircle" size={20} className="text-primary flex-shrink-0 ml-2" />
                )}
              </div>

              <div className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">Motor:</span>
                  <span className="font-medium text-foreground">{version?.engine}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">Transmisión:</span>
                  <span className="font-medium text-foreground">{version?.transmission}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">Tracción:</span>
                  <span className="font-medium text-foreground">{version?.drivetrain}</span>
                </div>
              </div>

              <div className="mt-3 pt-3 border-t border-border">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">Precio Lista:</span>
                  <span className="font-semibold text-foreground">{version?.listPrice}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-2">
          {versions?.map((version) => (
            <div
              key={version?.id}
              className={`flex items-center justify-between p-4 border rounded-lg cursor-pointer transition-smooth ${
                selectedVersion?.id === version?.id
                  ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
              }`}
              onClick={() => onVersionSelect(version)}
            >
              <div className="flex items-center space-x-4 flex-1">
                <div className="flex-1">
                  <div className="flex items-center space-x-3">
                    <h4 className="font-medium text-foreground">{version?.trim}</h4>
                    <span className="text-sm text-muted-foreground">•</span>
                    <span className="text-sm text-muted-foreground">{version?.engine}</span>
                    <span className="text-sm text-muted-foreground">•</span>
                    <span className="text-sm text-muted-foreground">{version?.transmission}</span>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">{version?.description}</p>
                </div>
                <div className="text-right">
                  <div className="font-semibold text-foreground">{version?.listPrice}</div>
                  <div className="text-sm text-muted-foreground">{version?.drivetrain}</div>
                </div>
              </div>
              
              <div className="ml-4">
                {selectedVersion?.id === version?.id ? (
                  <Icon name="CheckCircle" size={20} className="text-primary" />
                ) : (
                  <Icon name="Circle" size={20} className="text-muted-foreground" />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {selectedVersion && (
        <div className="mt-6 p-4 bg-muted rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="CheckCircle" size={16} className="text-success" />
            <span className="text-sm font-medium text-foreground">Versión Seleccionada</span>
          </div>
          <p className="text-sm text-muted-foreground">
            {selectedVersion?.trim} - {selectedVersion?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default VersionSelector;